<template>
  <div id="commodityIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">商品</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage";
// 页面二级菜单
import SecondMenu from "components/layout/SecondMenu";
// 系统首页 二级菜单路由表
export default {
  data() {
    return {
      secondaryMenuMap: [
        {
          menuName: "商品列表",
          url: "/admin/commodity/list",
          keyword: "ROLE_GOODS_show",
          childrenMenu: []
        },
        {
          menuName: "商品辅助",
          url: "/admin/commodity/price-manage",
          childrenMenu: [
            {
              name: "商品价格",
              url: "/admin/commodity/price-manage",
              keyword: "ROLE_GOODS_show"
            },
            {
              name: "分类管理",
              url: "/admin/commodity/sort-manage",
              keyword: "ROLE_GOODS_others"
            },
            {
              name: "商品标签",
              url: "/admin/commodity/commodity-tag",
              keyword: "ROLE_GOODS_others"
            },
            {
              name: "商品品牌",
              url: "/admin/commodity/commodity-brand",
              keyword: "ROLE_GOODS_others"
            },
            {
              name: "参数管理",
              url: "/admin/commodity/parameter-manage",
              keyword: "ROLE_GOODS_others"
            }
          ]
        },
        {
          menuName: "运费管理",
          url: "/admin/commodity/freight",
          keyword: "ROLE_GOODS_traffic",
          childrenMenu: []
        }
      ],
      authorityList: ""
    };
  },
  methods: {
    onMenuConfirm(url) {
      // 路由跳转
      console.log("路由--", url);
      this.$router.push({
        path: url
      });
    }
  },
  components: {
    SecondMenu
  },
  mounted() {
    this.authorityList = getDBOperationPermission();
    if (
      this.authorityList.indexOf("ROLE_GOODS_show") === -1 ||
      this.authorityList.indexOf("ROLE_GOODS_manage") === -1
    ) {
      this.secondaryMenuMap[1].childrenMenu.splice(0, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
